export default "__VITE_ASSET__DcgZZmxx__"